import metrics from './metrics.js'

const MetricListPage = () => {
  
  console.log('metrics are', metrics);
  return (
    <div>

      <div className="container mx-auto max-w-4xl">

        {/* Navigation header */}
        <div className="md:mb-6 lg:mb-6 py-4 flex justify-between items-top">

          <img src="/blue_green_KGLogo_bold.png" alt="Logo" className="w-auto h-10"/>
        
          
          {/* Campaign site */}
          <div>
            <a href="https://www.kgfornyc.com" className="rounded-xl p-2 hover:bg-gray-100 text-gray-300 -mr-2 text-sm font-regular">
              campaign website
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-4 w-4 inline ml-1 mb-0.5">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </span>
            </a>
          </div>    
        </div>
        {/* end of navigation header */}
      
        <div className="my-8 text-6xl font-bold text-center">
          Do you expect <span className="underline">results</span> from your next mayor?
        </div>

        <div className="my-8 text-xl font-medium text-gray-400 text-center px-8">
          Voters deserve meaningful, measurable change from City Hall &mdash; not just words. Kathryn Garcia believes in showing your work and delivering results. <span>Here's what you can expect from her first term.</span>
        </div>


        <div className="grid grid-cols-3 gap-4 my-8">
          {metrics.map((metric, i) => {
            const isReady = !!metric.slug;
            const textColor = isReady ? 'text-white' : 'text-black';
            const bgColor = isReady ? 'bg-secondarygreen' : 'bg-gray-100';
            const hoverbgColor = isReady ? 'transition transform hover:-translate-y-0.5 hover:shadow-2xl' : 'hover:bg-gray-100';
            const themeText = isReady ? metric.topic : 'coming soon';
            const linkProps = isReady ? {
              href: `/metrics/${metric.slug}` 
            } : {};
            return (
              <a key={metric.slug} {...linkProps} className={`block h-72 rounded-xl ${bgColor} ${hoverbgColor} p-8 flex flex-col`}>
                <div className={`text-xl font-bold ${textColor} opacity-30 mb-4`}>{themeText}</div>
                <div className={`text-2xl font-bold ${textColor}`}>{metric.name}</div>
              </a>
            )
          })}
        </div>


        <section class="bg-white overflow-hidden my-8">
          <div class="relative max-w-7xl mx-auto pt-20 pb-12 px-4 sm:px-6 lg:px-8 lg:py-20">

            <div class="relative lg:flex lg:items-center">
              <div class="hidden lg:block lg:flex-shrink-0">
                <img class="h-24 w-24 rounded-full xl:h-32 xl:w-32 overflow-hidden" src="/kg.jpeg" alt=""/>
              </div>

              <div class="relative lg:ml-10">
                <svg class="absolute top-0 left-0 transform -translate-x-8 -translate-y-24 h-36 w-36 text-electricgreen opacity-50" stroke="currentColor" fill="none" viewBox="0 0 144 144" aria-hidden="true">
                  <path stroke-width="2" d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z" />
                </svg>
                <blockquote class="relative">
                  <div class="text-2xl leading-9 font-medium text-gray-900">
                    <p>
                    I envision not the New York of our past, but the New York of tomorrow.  A city where every child has the opportunity to pursue their dream. Where everyone can make a good living. A city where families are safe and healthy and people thrive.
                    </p>
                  </div>
                  <footer class="mt-8">
                    <div class="flex">
                      <div class="flex-shrink-0 lg:hidden">
                        <img class="h-12 w-12 rounded-full overflow-hidden" src="/kg.jpeg" alt=""/>
                      </div>
                      <div class="ml-4 lg:ml-0">
                        <div class="text-base font-medium text-gray-900">Kathryn Garcia</div>
                        <div class="text-base font-medium text-secondarygreen">Running for Mayor</div>
                      </div>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </section>

        
      </div>

      {/* Footer */}
      <div className="h-40 bg-gray-100">

        <div className="h-full container mx-auto max-w-4xl  flex justify-between items-center text-gray-500">
          <div>Copyright © 2021 KGforNYC</div>
          <div>👋 made with love in brooklyn</div>
        </div>
      </div>

    </div>


    
    
  )
}

export default MetricListPage;